import { supabase } from '@/integrations/supabase/client';

export interface PickerProduct {
  id: string;
  slug: string;
  title: string;
  subtitle: string | null;
  image: string | null;
}

/**
 * Search products for picker component
 */
export async function searchProducts(searchQuery: string): Promise<PickerProduct[]> {
  let query = supabase
    .from('products')
    .select('id, slug, title, subtitle, image')
    .eq('is_published', true)
    .order('title');

  if (searchQuery) {
    query = query.or(
      `title.ilike.%${searchQuery}%,subtitle.ilike.%${searchQuery}%`
    );
  }

  const { data, error } = await query.limit(50);

  if (error) throw error;
  return data || [];
}
